"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentElPropTypes = exports.componentElDefaults = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
utils for accepting DOM elements or react components
as component type to use for rendering
*/

var props = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].any]);
exports.componentElPropTypes = props;
var defaults = 'div';
exports.componentElDefaults = defaults;